import i18n from '../i18n';
import { intlLocaleFor } from '../i18n/languages';

export function getActiveLocale() {
  return intlLocaleFor(i18n.language);
}

export function formatNumber(value, options) {
  const num = Number(value);
  if (Number.isNaN(num)) return String(value ?? '');
  return num.toLocaleString(getActiveLocale(), options);
}

export function formatDateTime(value, options) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(getActiveLocale(), options);
}

export function formatTime(value, options) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString(getActiveLocale(), options);
}
